import { PROGRAM_SETTING_RULES } from '@/constants/programSettings';
import { Grid, Stack, Typography } from '@mui/material';
import { formatCurrency } from '@/utils/currency';
import { SVCurrencyInput } from '@/components/core';
import { FORM_FIELDS } from '@/constants/formFields';

export const InitialDepositControls = () => {
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="minimumInitDeposit"
            {...FORM_FIELDS.MINIMUM_INITIAL_DEPOSIT}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            Enter an amount between 0 and{' '}
            {formatCurrency({
              amount: PROGRAM_SETTING_RULES.MINIMUM_INITIAL_DEPOSIT,
            })}
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="maximumInitDeposit"
            {...FORM_FIELDS.MAXIMUM_INITIAL_DEPOSIT}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            Enter an amount between 0 and{' '}
            {formatCurrency({
              amount: PROGRAM_SETTING_RULES.MAXIMUM_INITIAL_DEPOSIT,
            })}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
